var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("WAITING...")]),_c('div',{staticClass:"msg"},[_vm._v("Reload soon, if no response please click the button below")]),_c('div',{staticClass:"msg"},[_vm._v("即将重新载入,如无反应请点击下面的按钮")]),_c('el-button',{attrs:{"plain":""},on:{"click":_vm.goback}},[_vm._v("back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }